import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api/v1',
  timeout: 15000
})

let isRedirectingToLogin = false

export function showLoginExpiredDialog() {
  const currentRoute = router.currentRoute
  const redirect = currentRoute.fullPath || window.location.pathname + window.location.search
  store.dispatch('logout')
  window.dispatchEvent(new CustomEvent('admin-auth-expired'))
  if (currentRoute.path !== '/login') {
    router.replace({
      path: '/login',
      query: { redirect }
    }).catch(() => {})
  }
  if (currentRoute.path === '/login' || isRedirectingToLogin) {
    return Promise.resolve()
  }
  isRedirectingToLogin = true
  return MessageBox.alert('登录已超时或登录状态已失效，请重新登录。', '需要重新登录', {
    confirmButtonText: '去登录',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false
  }).finally(() => {
    isRedirectingToLogin = false
  })
}

service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers.Authorization = `Bearer ${store.getters.token}`
  }
  return config
})

service.interceptors.response.use(
  response => response.data,
  error => {
    // 登录接口的401是账号密码校验失败，必须显示后台提示，不能当作会话过期吞掉。
    const requestUrl = error.config?.url || error.response?.config?.url || ''
    const isLoginRequest = /(?:^|\/)auth\/login(?:\?|$)/.test(requestUrl)
    if (error.response?.status === 401 && !isLoginRequest) {
      showLoginExpiredDialog()
      return Promise.reject(error)
    }
    const message = error.response?.data?.detail || error.message || '请求失败'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
